import * as React from 'react';

import styles from './empty-circle.module.css';

export function EmptyCircle({offsetTop}: {offsetTop: number}) {
    return (
        <div style={{marginTop: offsetTop}} className={styles['empty-circle']}>
            <svg viewBox='0 0 16 16'>
                <circle cx='8' cy='8' r='4' fill='white' />
            </svg>
        </div>
    );
}

EmptyCircle.defaultProps = {
    offsetTop: 9,
};
